import React, { useState, useRef } from "react";
import { auth } from "../../firebase";
import { useAuth } from "../../contexts/authContext";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import invalidFieldIndicator from "../../images/signup/invalidFieldIndicator.svg";
import { LockOutlined, UserOutlined, KeyOutlined } from "@ant-design/icons";
import { Alert, Button, Checkbox, Form, Input, Modal, message, Space } from "antd";
import Logo from ".././../images/logo_white_bg.png";

const SignIn = () => {
  const navigate = useNavigate();
  const { roles, logout } = useAuth();

  const { currentUser, login, googleSignIn } = useAuth();
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: false,
  });
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setStatus({ loading: true, success: false, error: "" });
      const res = await login(values.email, values.password);
      console.log("res in signin", res);

      const firebaseId = res.user._delegate.uid;
      setStatus({ loading: false, success: false, error: false });
      if (roles && roles.includes("COUNSELLOR")) {
        console.log("inside the counsellor flow");

        navigate("/counsellor/home");
      } else {
        console.log("outside ", roles);
        navigate("/");
      }
    } catch (error) {
      console.log("Some Error Has Occured");
      console.log(error);

      if (error.code === "auth/wrong-password") {
        setStatus({
          loading: false,
          error: "Incorrect Password",
          success: false,
        });
      } else if (error.code === "auth/user-not-found") {
        setStatus({
          loading: false,
          error: "No user found, contact Admin",
          success: false,
        });
      } else {
        setStatus({
          loading: false,
          error: "Something went Wrong",
          success: false,
        });
      }
    }
  };

  // Reset password function
  const handleResetPassword = async (values) => {
    try {
      setResetLoading(true);
      await auth.sendPasswordResetEmail(values.email);
      message.success("Password reset email sent! Please check your inbox.");
      setResetPasswordModal(false);
    } catch (error) {
      console.error("Error sending password reset email:", error);
      if (error.code === "auth/user-not-found") {
        message.error("No user found with this email address.");
      } else if (error.code === "auth/invalid-email") {
        message.error("Please enter a valid email address.");
      } else {
        message.error("Failed to send reset email. Please try again.");
      }
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "lightgray",
        padding: 0,
        position: "relative",
      }}
    >
      <img style={{ position: "absolute", top: "20px", left: "20px" }} src={Logo} width="100px" />
      {status.error && <Alert message={status.error} type="error" showIcon />}
      <h1>Login</h1>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your Email!",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Email"
            type="email"
            onChange={() => {
              setStatus({ loading: false, success: false, error: false });
            }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your Password!",
            },
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            onChange={() => {
              setStatus({ loading: false, success: false, error: false });
            }}
          />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            span: 20,
            // offset: 4,
          }}
        >
          <Button type="primary" htmlType="submit" className="login-form-button" loading={status.loading}>
            Login
          </Button>
        </Form.Item>

        <Form.Item style={{ textAlign: "center", marginBottom: 0 }}>
          <Button type="link" icon={<KeyOutlined />} onClick={() => setResetPasswordModal(true)} style={{ color: "#1890ff" }}>
            Forgot Password?
          </Button>
        </Form.Item>
      </Form>

      {/* Reset Password Modal */}
      <Modal title="Reset Password" open={resetPasswordModal} onCancel={() => setResetPasswordModal(false)} footer={null} centered>
        <Form name="reset_password" onFinish={handleResetPassword} layout="vertical">
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              {
                required: true,
                message: "Please input your email address!",
              },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Enter your email address" size="large" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Space>
              <Button onClick={() => setResetPasswordModal(false)}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={resetLoading} icon={<KeyOutlined />}>
                Send Reset Email
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SignIn;
